export default __webpack_public_path__ + "static/media/pic_orderstep_03.8b872693.png";